import Vuex from 'vuex';
import Vue from 'vue';

import AppModule from './app';
import AdminModule from './admin';

// Load
Vue.use(Vuex);

// create store
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    admin: AdminModule
  }
});

export default store;
